import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["min", "max", "disabled"]
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-xs text-black italic"
}
const _hoisted_6 = {
  key: 1,
  class: "text-red-500 text-sm mt-1"
}
const _hoisted_7 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_10 = { class: "flex items-center space-x-6" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "mt-1 text-xs text-black italic"
}
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_21 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}
const _hoisted_22 = { class: "flex justify-end space-x-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "animate-spin h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { reactive, watch, ref, computed } from 'vue'
import { ModalComp } from '@/components'
import BuyerAutocomplete from '@/components/forms/BuyerAutocomplete.vue'
import type { AddPromoModalProps, AddPromoModalEmits, PromoFormData } from '@/types/promoModal'


export default /*@__PURE__*/_defineComponent({
  __name: 'AddPromoModal',
  props: {
    isVisible: { type: Boolean },
    isSubmitting: { type: Boolean }
  },
  emits: ["update:isVisible", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const formData = reactive<PromoFormData>({
  code: '',
  acheteurId: null,
  acheteur: '', // Gardé pour compatibilité
  type: 'percentage',
  montant: '',
  montantMin: '',
  localisation: '1',
  utilisation: 'unique',
  actif: 'true',
  dateDebut: '',
  dateFin: '',
  premiereCommande: false,
  offert: false,
  cumulable: true
})

const buyerAutocompleteRef = ref<{ clearSelection: () => void } | null>(null)

// Messages d'erreur
const validationErrors = ref({
  montant: '',
  montantMin: '',
  dateRange: ''
})

// Validation des montants
const validateMontants = () => {
  const montantMin = parseFloat(formData.montantMin)
  
  // Réinitialiser les erreurs
  validationErrors.value.montantMin = ''

    // Validation montant minimum
    if (formData.montantMin && montantMin < 0) {
      validationErrors.value.montantMin = 'Le montant minimum ne peut pas être négatif'
    }

}

// Validation des dates
const validateDates = () => {
  validationErrors.value.dateRange = ''
  
  if (formData.dateDebut && formData.dateFin) {
    const dateDebut = new Date(formData.dateDebut)
    const dateFin = new Date(formData.dateFin)
    
    if (dateFin <= dateDebut) {
      validationErrors.value.dateRange = 'La date de fin doit être postérieure à la date de début'
    }
  }
}

// Validation du formulaire
const isFormValid = computed(() => {
  // Vérifier que tous les champs requis sont remplis (sauf acheteur et montantMin qui sont optionnels)
  const allFieldsFilled = formData.code && 
                         formData.type && 
                         formData.montant && 
                         formData.localisation && 
                         formData.dateDebut && 
                         formData.dateFin && 
                         formData.utilisation &&
                         formData.actif

  // Vérifier que la date de fin est après la date de début
  const datesValid = formData.dateDebut && formData.dateFin 
    ? new Date(formData.dateFin) > new Date(formData.dateDebut)
    : true

  const montantsValid = !validationErrors.value.montant && 
                       !validationErrors.value.montantMin && 
                       !validationErrors.value.dateRange

  return allFieldsFilled && datesValid && montantsValid
})

// Read-only computed from prop to use in template
const isSubmitting = computed(() => !!props.isSubmitting)

// Watchers pour valider en temps réel
watch([() => formData.montantMin], validateMontants)
watch([() => formData.dateDebut, () => formData.dateFin], validateDates)

const handleSubmit = () => {
  // Convertir l'ID acheteur en string pour compatibilité et appliquer les valeurs par défaut
  const submitData = {
    ...formData,
    acheteur: formData.acheteurId ? formData.acheteurId.toString() : 'tous',
    montantMin: formData.montantMin || '0',
  }
  emit('submit', submitData)
}

const handleBuyerChange = (buyerId: number | null) => {
  formData.acheteurId = buyerId
}

const clearBuyer = () => {
  formData.acheteurId = null
  formData.acheteur = 'tous'
  buyerAutocompleteRef.value?.clearSelection()
}

const handleOffertChange = () => {
  if (formData.offert) {
    // Si "Offert" est coché, mettre le montant à 100% et le type à "pourcentage"
    formData.montant = '100'
    formData.type = 'percentage'
  } else {
    // Si "Offert" est décoché, remettre les valeurs par défaut
    formData.montant = ''
    formData.type = 'percentage'
  }
}

const handleMontantChange = () => {
  const montant = parseFloat(formData.montant)
  
  // Validation selon le type
  if (formData.type === 'percentage') {
    if (montant < 1) {
      validationErrors.value.montant = 'Le pourcentage doit être entre 1% et 100%'
    } else if (montant > 100) {
      validationErrors.value.montant = 'Le pourcentage ne peut pas dépasser 100%'
    } else {
      validationErrors.value.montant = ''
    }
    
    // Si l'utilisateur met 100%, cocher automatiquement "offert"
    if (montant === 100) {
      formData.offert = true
    } else if (montant !== 100) {
      // Si ce n'est plus 100%, décocher "offert"
      formData.offert = false
    }
  } else if (formData.type === 'fixed') {
    if (montant < 0) {
      validationErrors.value.montant = 'Le montant fixe ne peut pas être négatif'
    } else {
      validationErrors.value.montant = ''
    }
  }
}

const handleTypeChange = () => {
  // Si on change de type, décocher "offert" si ce n'est plus un pourcentage
  if (formData.type !== 'percentage') {
    formData.offert = false
  } else {
    // Si on revient en pourcentage, vérifier si c'est 100%
    const montant = parseFloat(formData.montant)
    if (montant === 100) {
      formData.offert = true
    }
  }
}

const handleNumberWheel = (event: WheelEvent) => {
  // Keep page scrolling while preventing wheel from incrementing/decrementing number inputs.
  const input = event.target as HTMLInputElement | null
  input?.blur()
}

const handlePremiereCommandeChange = () => {
  if (formData.premiereCommande) {
    // Si "Réservé aux nouveaux clients" est coché, forcer "Utilisation unique"
    formData.utilisation = 'unique'
  }
  // Si on décoche "Réservé aux nouveaux clients", on laisse l'utilisateur choisir
}

// Reset form when modal opens
watch(() => props.isVisible, (newValue) => {
  if (newValue) {
    Object.assign(formData, {
      code: '',
      acheteurId: null,
      acheteur: 'tous',
      type: 'percentage',
      montant: '',
      montantMin: '',
      localisation: '1',
      // Defaults required: Utilisation = 'unique', Actif = 'true' (Oui)
      utilisation: 'unique',
      actif: 'true',
      dateDebut: '',
      dateFin: '',
      premiereCommande: false,
      offert: false,
      cumulable: true
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalComp), {
    isVisible: _ctx.isVisible,
    title: "Création d'un code promo",
    size: "lg",
    "onUpdate:isVisible": _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('update:isVisible', $event)))
  }, {
    body: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"]),
        class: "space-y-6"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
              _createTextVNode("Code Promo "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.code) = $event)),
              type: "text",
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
              required: ""
            }, null, 512), [
              [_vModelText, formData.code]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Acheteur", -1)),
            _createVNode(BuyerAutocomplete, {
              ref_key: "buyerAutocompleteRef",
              ref: buyerAutocompleteRef,
              modelValue: formData.acheteurId,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((formData.acheteurId) = $event)),
                handleBuyerChange
              ],
              placeholder: "Rechercher un acheteur..."
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", { class: "mt-2 flex items-center gap-2" }, [
              _createElementVNode("button", {
                type: "button",
                onClick: clearBuyer,
                class: "text-sm text-blue-600 hover:text-blue-800 underline"
              }, " Effacer la sélection "),
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-sm text-black" }, " (Laisser vide pour cibler tous les acheteurs) ", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
              _createTextVNode("Type "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.type) = $event)),
              onChange: handleTypeChange,
              disabled: formData.offert,
              class: _normalizeClass(["w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent", formData.offert ? 'bg-gray-100 cursor-not-allowed' : 'bg-white']),
              required: ""
            }, _cache[19] || (_cache[19] = [
              _createElementVNode("option", { value: "percentage" }, "Pourcentage", -1),
              _createElementVNode("option", { value: "fixed" }, "Montant fixe", -1)
            ]), 42, _hoisted_3), [
              [_vModelSelect, formData.type]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
              _createTextVNode("Montant de la promo "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.montant) = $event)),
              onInput: handleMontantChange,
              onWheel: handleNumberWheel,
              type: "number",
              step: "0.01",
              min: formData.type === 'percentage' ? '1' : '0',
              max: formData.type === 'percentage' ? '100' : '',
              disabled: formData.offert,
              class: _normalizeClass(["w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent", formData.offert ? 'bg-gray-100 cursor-not-allowed' : 'bg-white']),
              required: ""
            }, null, 42, _hoisted_4), [
              [_vModelText, formData.montant]
            ]),
            (formData.offert)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 🔒 Verrouillé à 100% car \"Offert\" est activé "))
              : _createCommentVNode("", true),
            (validationErrors.value.montant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(validationErrors.value.montant), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Montant minimum", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.montantMin) = $event)),
              onWheel: handleNumberWheel,
              type: "number",
              step: "0.01",
              min: "0",
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            }, null, 544), [
              [_vModelText, formData.montantMin]
            ]),
            (validationErrors.value.montantMin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(validationErrors.value.montantMin), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
              _createTextVNode("Localisation "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.localisation) = $event)),
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
              required: ""
            }, _cache[23] || (_cache[23] = [
              _createElementVNode("option", { value: "1" }, "Tous", -1),
              _createElementVNode("option", { value: "2" }, "France", -1),
              _createElementVNode("option", { value: "3" }, "DOM-TOM", -1),
              _createElementVNode("option", { value: "5" }, "Europe", -1),
              _createElementVNode("option", { value: "4" }, "International", -1)
            ]), 512), [
              [_vModelSelect, formData.localisation]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
              _createTextVNode("Actif "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.actif) = $event)),
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
              required: ""
            }, _cache[25] || (_cache[25] = [
              _createElementVNode("option", { value: "false" }, "Non", -1),
              _createElementVNode("option", { value: "true" }, "Oui", -1)
            ]), 512), [
              [_vModelSelect, formData.actif]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
              _createTextVNode("Utilisation "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.utilisation) = $event)),
                  type: "radio",
                  value: "unique",
                  disabled: formData.premiereCommande,
                  class: _normalizeClass(["mr-2 text-blue-600 focus:ring-blue-500", formData.premiereCommande ? 'opacity-50 cursor-not-allowed' : ''])
                }, null, 10, _hoisted_12), [
                  [_vModelRadio, formData.utilisation]
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-sm text-black", formData.premiereCommande ? 'text-black' : ''])
                }, "Unique", 2)
              ]),
              _createElementVNode("label", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.utilisation) = $event)),
                  type: "radio",
                  value: "multiple",
                  disabled: formData.premiereCommande,
                  class: _normalizeClass(["mr-2 text-blue-600 focus:ring-blue-500", formData.premiereCommande ? 'opacity-50 cursor-not-allowed' : ''])
                }, null, 10, _hoisted_14), [
                  [_vModelRadio, formData.utilisation]
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-sm text-black", formData.premiereCommande ? 'text-black' : ''])
                }, "Multiple", 2)
              ])
            ]),
            (formData.premiereCommande)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 🔒 Verrouillé car \"Réservé aux nouveaux clients\" est activé "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Première commande uniquement", -1)),
            _createElementVNode("label", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.premiereCommande) = $event)),
                onChange: handlePremiereCommandeChange,
                type: "checkbox",
                class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              }, null, 544), [
                [_vModelCheckbox, formData.premiereCommande]
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "ml-2 text-sm text-black" }, "Réservé aux nouveaux clients", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Offert", -1)),
            _createElementVNode("label", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.offert) = $event)),
                type: "checkbox",
                class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2",
                onChange: handleOffertChange
              }, null, 544), [
                [_vModelCheckbox, formData.offert]
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "ml-2 text-sm text-black" }, "Code promo à 100% (gratuit)", -1))
            ]),
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "mt-1 text-xs text-black italic" }, " Commande gratuite (codes de bienvenue, compensation, etc.) ", -1))
          ]),
          _createElementVNode("div", null, [
            _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, "Cumulable", -1)),
            _createElementVNode("label", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.cumulable) = $event)),
                type: "checkbox",
                class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              }, null, 512), [
                [_vModelCheckbox, formData.cumulable]
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "ml-2 text-sm text-black" }, "Peut être combiné avec d'autres codes", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", null, [
            _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
              _createTextVNode("Début (jj/mm/aaaa) "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.dateDebut) = $event)),
              type: "date",
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
              required: ""
            }, null, 512), [
              [_vModelText, formData.dateDebut]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block text-sm font-medium text-black mb-2" }, [
              _createTextVNode("Fin (jj/mm/aaaa) "),
              _createElementVNode("span", { class: "text-red-500" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.dateFin) = $event)),
              type: "date",
              class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
              required: ""
            }, null, 512), [
              [_vModelText, formData.dateFin]
            ]),
            (validationErrors.value.dateRange)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(validationErrors.value.dateRange), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('update:isVisible', false))),
          type: "button",
          class: "px-4 py-2 text-black bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none transition-colors"
        }, " Annuler "),
        _createElementVNode("button", {
          type: "submit",
          onClick: handleSubmit,
          disabled: !isFormValid.value || isSubmitting.value,
          class: _normalizeClass(["px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none transition-colors inline-flex items-center gap-2", (!isFormValid.value || isSubmitting.value) ? 'opacity-50 cursor-not-allowed' : ''])
        }, [
          (isSubmitting.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_24, _cache[37] || (_cache[37] = [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }, null, -1),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(isSubmitting.value ? 'Ajout...' : 'Ajouter'), 1)
        ], 10, _hoisted_23)
      ])
    ]),
    _: 1
  }, 8, ["isVisible"]))
}
}

})